import { stdObject } from "./types/stdObject";

export const brandsHeaders: stdObject[] = [
  {
    code: "FORMAR",
    label: "p.image",
    type: "image",
    idCode: "CODMAR",
    folder: "brands",
    align: "center",
  },
  { code: "NOMMAR", label: "p.name" },
];
